import * as React from 'react';
import { useSelector } from 'react-redux';

import { AppState } from 'services/types';
import { FertilizerEntityId } from 'services/fertilizerEvents/types';
import { EntityDropdownOptions } from '../../types';
import { makeSelectFertilizerInnerEntityOptions } from './selectors';

type ChildrenFunction = (values: any) => React.ReactElement;

export interface Props {
    options: EntityDropdownOptions;
    children: React.ReactElement | ChildrenFunction;
    fertilizerEntityId?: FertilizerEntityId;
}

export default function FertilizerSchemaInnerEntityOptions(
    props: Props
): React.ReactElement {
    const { children } = props;

    const fertilizerInnerEntityOptions = useSelector((state: AppState) =>
        makeSelectFertilizerInnerEntityOptions()(state, props)
    );

    if (typeof children === 'function') {
        return children(fertilizerInnerEntityOptions);
    }

    // @ts-ignore
    return React.cloneElement(children, { fertilizerInnerEntityOptions });
}
